import { z } from 'zod';

const CreateSegmentSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }).max(200),
  description: z.string().max(2000).optional().or(z.literal('')),
  query: z.any().refine((v) => v && typeof v === 'object' && !Array.isArray(v), {
    message: 'Query must be a JSON object (e.g. {"and":[]})',
  }),
});

export default CreateSegmentSchema;
